import Sad from '@direct-frontend/components/src/icons/illustrated/Character/CharacterWhiteSad.svg';
import { ErrorBlank } from '../../ErrorBlank';
import { withImage } from '../../lib/hoc/withImage';

/**
 * Компонент отображения ошибок с подставленным изображением Sad
 * @kind component
 */
export const ErrorBlankSad = withImage(ErrorBlank, {
    imageSrc: Sad,
    imageAlt: 'Ошибка',
});
